export function Logo(props) {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/assets/logo_192px.png"
        {...props}
        className="max-w-16 h-8"
        alt="Fluvo"
      />
    </div>
  );
}
